import { Module } from '@nestjs/common';
import { ContabilidadModule } from 'src/contabilidad/contabilidad.module';
import { PrismaModule } from 'src/prisma/prisma.module';
import { PagosProveedorController } from './pagos-proveedor.controller';
import { PagosProveedorService } from './pagos-proveedor.service';

@Module({
  imports: [PrismaModule, ContabilidadModule],
  controllers: [PagosProveedorController],
  providers: [PagosProveedorService],
  exports: [PagosProveedorService],
})
export class PagosProveedorModule {}
